
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pecas/contato",
      function () {
        return require("private-next-pages/pecas/contato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pecas/contato"])
      });
    }
  